import { useQuery } from '@tanstack/react-query'
import { RetrieveSignatureSessionResponseBody } from 'bff'
import { useSignature } from '../components/Signing'
import { useEffect } from 'react'
import {
  useSignatureSessionQuery,
  UseSignatureSessionQueryProps,
} from './useSignatureSessionQuery'

export const useReactiveSignatureSession = (
  initialSignatureSession: RetrieveSignatureSessionResponseBody,
  opts: UseSignatureSessionQueryProps = {
    reactiveQueryEnabled: true,
  }
) => {
  const { expireSignatureSession } = useSignature()

  const query = useSignatureSessionQuery(initialSignatureSession, opts)

  useEffect(() => {
    return () => {
      expireSignatureSession().catch(console.error)
    }
  }, [])

  return {
    query,
  }
}
